import React from 'react';
import { Box, Typography } from '@mui/material';
import { trozosConNombre } from '../config/personalizacion';
import { BLOCK_HEADING, BLOCK_LIST, BLOCK_QUOTE } from '../content/blocks';

const LINE_BREAK = '\n';

const NamedText = ({ text, name, nameColor }) =>
  trozosConNombre(text, name).map((trozo, i) =>
    trozo.esNombre
      ? <Box component="strong" key={i} sx={{ color: nameColor, fontWeight: 600 }}>{trozo.texto}</Box>
      : <React.Fragment key={i}>{trozo.texto}</React.Fragment>
  );

/** The runs of one item: marks become strong/em elements, never raw html. */
export const InlineRuns = ({ runs, name, nameColor }) =>
  runs.map((run, i) => {
    if (run.text === LINE_BREAK) return <br key={i} />;
    let node = <NamedText text={run.text} name={name} nameColor={nameColor} />;
    if (run.italic) node = <em>{node}</em>;
    if (run.bold) node = <strong>{node}</strong>;
    return <React.Fragment key={i}>{node}</React.Fragment>;
  });

/** The body of a piece, block by block, with the reading classes of canalizacion.css. */
const PieceBlocks = ({ blocks, name = '', nameColor }) =>
  blocks.map((block, i) => {
    const inline = (runs) => <InlineRuns runs={runs} name={name} nameColor={nameColor} />;
    if (block.type === BLOCK_HEADING) {
      return <Typography key={i} component="h3" className="subtitulo-pieza">{inline(block.items[0])}</Typography>;
    }
    if (block.type === BLOCK_LIST) {
      return (
        <Box key={i} component="ul" className="lista-pieza">
          {block.items.map((runs, j) => <li key={j}>{inline(runs)}</li>)}
        </Box>
      );
    }
    if (block.type === BLOCK_QUOTE) {
      return <Box key={i} component="blockquote" className="parrafo cita-pieza">{inline(block.items[0])}</Box>;
    }
    return (
      <Typography key={i} component="p" className={i === 0 ? 'parrafo primero' : 'parrafo'}>
        {inline(block.items[0])}
      </Typography>
    );
  });

export default PieceBlocks;
